<mat-card>

    <mat-card-content>
        <mat-label
                class="distance-label">{{'Distance' | translate }} {{': ' + dataExchangeService.pointsDistance.toFixed(2) + ' cm'}}</mat-label>
    </mat-card-content>

</mat-card>
